module.exports = __webpack_public_path__ + "static/case2_529-a8c7673113bfda023d83fd13d1082b25.jpeg";